// BIGLI-80（PM 2026-09-24 附截圖）：所有日期欄位不再只認右邊的日曆 icon —
// 讓 <input type="date"> 全欄可點，點到任意位置就跳出日期選擇器。
// 做法：搭配 common.css 隱掉 ::-webkit-calendar-picker-indicator，再由這裡
// 攔截 document 級的 click / keydown，呼叫該欄自己的 HTMLInputElement.showPicker()。
// showPicker 支援度：Chrome 99+ / Edge 99+ / Firefox 101+ / Safari 16+ —— 已涵蓋 PM
// 使用的桌面環境；不支援時 catch 掉，focus 後仍可用鍵盤輸入或系統回退到原生 icon。

const DATE_INPUT_SELECTOR = 'input[type="date"]';

const shouldOpenPicker = (input) => {
  if (!input || input.tagName !== 'INPUT') return false;
  if (input.type !== 'date') return false;
  if (input.disabled) return false;
  if (input.readOnly) return false;
  return true;
};

const openPicker = (input) => {
  if (!shouldOpenPicker(input)) return;
  try {
    if (typeof input.showPicker === 'function') {
      input.showPicker();
    }
  } catch {
    // Firefox 會在非使用者手勢下丟 NotAllowedError，
    // 這裡的 handler 一定是使用者互動觸發的，還是保個底避免 crash 整頁。
  }
};

const handleClick = (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const input = target.closest(DATE_INPUT_SELECTOR);
  if (!input) return;
  // 已聚焦的欄位再點一次也要能重新叫出選擇器
  // （原生 icon 已藏起來，否則就沒地方可以再開）。
  openPicker(input);
};

const handleKeyDown = (event) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  const target = event.target;
  if (!(target instanceof Element)) return;
  const input = target.closest(DATE_INPUT_SELECTOR);
  if (!input) return;
  event.preventDefault();
  openPicker(input);
};

export const installDateInputExpand = (doc = typeof document !== 'undefined' ? document : null) => {
  if (!doc || typeof doc.addEventListener !== 'function') {
    return () => {};
  }
  doc.addEventListener('click', handleClick);
  doc.addEventListener('keydown', handleKeyDown);
  return () => {
    doc.removeEventListener('click', handleClick);
    doc.removeEventListener('keydown', handleKeyDown);
  };
};
